/** Minecraft-like team colors for common team ids (BedWars and friends). */
const TEAM_COLORS: Record<string, { color: string; label: string }> = {
  red: { color: '#d94a4a', label: 'Rossa' },
  blue: { color: '#4a74d9', label: 'Blu' },
  green: { color: '#4fae4a', label: 'Verde' },
  lime: { color: '#8bd14a', label: 'Lime' },
  yellow: { color: '#e5c443', label: 'Gialla' },
  gold: { color: '#e09a2b', label: 'Oro' },
  orange: { color: '#e57f2e', label: 'Arancione' },
  aqua: { color: '#3fc1c9', label: 'Acqua' },
  cyan: { color: '#2a9fa8', label: 'Ciano' },
  white: { color: '#d8d8d8', label: 'Bianca' },
  gray: { color: '#8a8a8a', label: 'Grigia' },
  grey: { color: '#8a8a8a', label: 'Grigia' },
  pink: { color: '#e57fb5', label: 'Rosa' },
  purple: { color: '#9a5cd1', label: 'Viola' },
  black: { color: '#3a3a3a', label: 'Nera' },
};

export function teamColor(teamId: string | null | undefined): string | null {
  if (!teamId) return null;
  return TEAM_COLORS[teamId.toLowerCase()]?.color ?? null;
}

export function teamLabel(teamId: string): string {
  return TEAM_COLORS[teamId.toLowerCase()]?.label ?? teamId;
}
